import type { ChildrenProps, ClassNameProps } from "../types";
import { cn } from "../utils";

export function DataGridCell({ children, className }: ChildrenProps & ClassNameProps) {
	return <div className={cn("[&_>*]:!font-medium [&_>*]:!text-md", className)}>{children}</div>;
}
